export default "__VITE_ASSET__MwdPbgBf__"